import React, { useContext, useEffect, useState } from "react";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { getCta } from "../hooks/getCta";
import DeepLinkModal from "../component/DeepLinkModal";
import { deleteCta } from "../hooks/deleteCta";
import { AppContext } from "../context/context";
import toast from "react-hot-toast";
import Pagination from "../component/Pagination";
import ConfirmDeleteModal from "../component/ConfirmDeleteModal";

const DeepLink = () => {
  const { state, dispatch } = useContext(AppContext);
  const [selectedState, setSelectedState] = useState({});
  const [openModal, setOpenModal] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  selectedState.source =
    state.activeTab === "ABCD App" ? "abcd_app" : "service_app";

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = (e) => {
    setSearchInput(e.target.value);
    setPage(0);
  };

  const filteredData = searchInput
    ? tableData.filter((item) =>
        Object.values(item).some((value) =>
          String(value).toLowerCase().includes(searchInput.toLowerCase())
        )
      )
    : tableData;

  const getCtaLinks = async () => {
    setLoading(true);
    try {
      const response = await getCta(selectedState.source);
      setLoading(false);
      dispatch({
        type: "SETCTALINKS",
        payload: response
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleDeleteCta = async (selectedState) => {
    try {
      toast.loading("loading...");
      await deleteCta(selectedState);
      await getCtaLinks();
      toast.dismiss();
      toast.success("Deleted Successfully");
      handleModalClose();
    } catch (error) {
      console.log("Error:", error);
      toast.dismiss();
      toast.error("Something went wrong");
    }
  };

  const handleModalClose = () => {
    setSelectedState({});
    setOpenModal(null);
  };

  useEffect(() => {
    setTableData(state.ctaLinks);
  }, [state.ctaLinks]);

  useEffect(() => {
    getCtaLinks();
  }, []);

  return (
    <>
      <div className="h-[calc(100%_-_56px)] pb-2 mt-2">
        <div className="flex items-center justify-between">
          <p className="text-lg font-medium text-[#424242]">
            List of Deep links
          </p>
          <button
            className="flex items-center justify-center gap-1.5 h-8 rounded-md bg-[#C7222A] text-white text-sm w-[6rem]"
            onClick={() => {
              setSelectedState({});
              setOpenModal("add");
            }}
          >
            <p>Add Row</p>
            <img className="h-[14px]" src={assetsManager?.addIcon} alt="" />
          </button>
        </div>
        <div className="flex flex-col gap-2 h-[calc(100%_-_32px)]">
          <div className="w-full relative">
            <img
              className="absolute top-1/2 transform translate-y-[-50%] left-[14px] h-[13px]"
              src={assetsManager.searchIcon}
              alt=""
            />
            <input
              className="w-[29rem] rounded-[4px] p-2 px-9 focus:outline-none bg-[#EFEFEF] text-sm"
              placeholder="Search Query"
              onChange={handleSearch}
              value={searchInput}
            />
          </div>
          <div className="h-[calc(100%_-_36px)] overflow-y-auto relative flex flex-col justify-between">
            <table className={`w-full table-fixed ${"sticky top-0"}`}>
              <thead className="sticky top-0">
                <tr className="w-fit">
                  {state.activeTab === "Service App" && (
                    <th className="border-b-[2px] border-[#EAECF0] text-sm p-2 px-4 bg-[#F8F8F8] font-medium text-start">
                      <p>LOB</p>
                    </th>
                  )}
                  <th className="border-b-[2px] border-[#EAECF0]  text-sm p-2 px-4 bg-[#F8F8F8] font-medium text-start">
                    <p>CTA</p>
                  </th>
                  <th className="border-b-[2px] border-[#EAECF0] text-sm p-2 px-4 bg-[#F8F8F8] font-medium text-start">
                    <p>CTA Description</p>
                  </th>
                  <th className="border-b-[2px] border-[#EAECF0] text-sm p-2 px-4 bg-[#F8F8F8] font-medium text-start">
                    <p>Deeplinks - APP</p>
                  </th>
                  <th className="border-b-[2px] border-[#EAECF0] text-sm p-2 px-4 bg-[#F8F8F8] font-medium text-start">
                    <p>Action</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 &&
                  paginatedData.map((item) => (
                    <tr key={item.id} className="border-b-[2px] border-none">
                      {state.activeTab === "Service App" && (
                        <td className="border-none text-sm p-3 text-[#667085] px-4 text-start">
                          <p>{item["lob name"]}</p>
                        </td>
                      )}
                      <td className="border-none text-sm p-3 text-[#667085] px-4 text-start">
                        <p>{item["cta name"]}</p>
                      </td>
                      <td className="border-none text-sm p-3 text-[#667085] px-4 text-start">
                        <p>{item?.description}</p>
                      </td>
                      <td className="border-none text-sm p-3 px-4 text-start">
                        <a
                          href={item?.deeplink}
                          className="!text-[#1C4EB2] ellipsis-text"
                          title={item?.deeplink}
                        >
                          {item?.deeplink}
                        </a>
                      </td>
                      <td className="border-none text-sm p-3 px-4 text-start">
                        <div className="flex justify-start items-center gap-4">
                          <img
                            src={assetsManager.edit}
                            alt="edit"
                            onClick={() => {
                              setSelectedState(item);
                              setOpenModal("edit");
                            }}
                            className="cursor-pointer"
                          />
                          <img
                            src={assetsManager.deleteIcon}
                            alt="delete"
                            onClick={() => {
                              setSelectedState(item);
                              setOpenModal("delete");
                            }}
                            className="cursor-pointer"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {filteredData.length <= 0 && (
              <div className=" h-[calc(100%_-_36px)] flex items-center justify-center">
                {loading ? (
                  "Loading..."
                ) : (
                  <img
                    className="h-2/3 min-h-24 max-h-48"
                    src={assetsManager.emptyIllustration}
                    alt=""
                  />
                )}
              </div>
            )}
          </div>
          {/* Add Pagination component */}
          <Pagination
            data={filteredData}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
          />
        </div>
        {(openModal === "edit" || openModal === "add") && (
          <DeepLinkModal
            openModal={openModal}
            selectedState={selectedState}
            setSelectedState={setSelectedState}
            setOpenModal={setOpenModal}
            getCtaLinks={getCtaLinks}
          />
        )}
        {openModal === "delete" && (
          <ConfirmDeleteModal
            handleModalClose={handleModalClose}
            handleDelete={() => handleDeleteCta(selectedState)}
          />
        )}
      </div>
    </>
  );
};

export default DeepLink;
